import React from 'react'

import {useParams} from './hooks'

type Props = {
  path: string
}

const Route: React.FC<React.PropsWithChildren<Props>> = ({path, children}) => {
  const {tab} = useParams()

  if (path === tab) {
    return children as React.ReactElement
  }

  return null
}

export default Route
